/**
 * Identidade visual de um evento nas telas compartilhadas.
 *
 * As landings de evento sao paginas proprias, cada uma com o seu visual. Ja o
 * checkout e a confirmacao sao uma tela so para todos — o inscrito saia de uma
 * pagina inteira do ACAMP e caia numa tela branca generica na hora de pagar,
 * justo no momento em que mais precisa reconhecer onde esta.
 *
 * Mapa por slug, no codigo, como `CODIGOS_CATEGORIA` na pagina do ACAMP: evento
 * novo exige deploy, que e exatamente como as landings ja funcionam. Quando
 * houver um segundo evento pedindo isso, o caso real dira se vale mover para o
 * banco — hoje seria adivinhacao.
 *
 * Evento fora do mapa fica com o visual atual, inalterado.
 */

/**
 * O veu e tao importante quanto a imagem: sem ele a foto compete com o cartao e
 * o QR fica dificil de ler. E o mesmo tratamento da hero da landing, para as
 * duas telas parecerem a mesma pagina.
 */
const VEU_ACAMP =
  'radial-gradient(ellipse 78% 52% at 50% 46%, rgba(8, 10, 26, 0.62) 0%, transparent 78%),' +
  'radial-gradient(ellipse 90% 60% at 50% 38%, rgba(80, 0, 248, 0.2) 0%, transparent 62%),' +
  'linear-gradient(180deg, rgba(8, 10, 26, 0.88) 0%, rgba(8, 10, 26, 0.55) 34%,' +
  ' rgba(8, 10, 26, 0.8) 74%, rgba(8, 10, 26, 0.97) 100%)'

const TEMAS = {
  'acamp-jovem-2k27': {
    fundo: '/eventos/acamp-jovem-2k27/hero.webp',
    veu: VEU_ACAMP
  }
}

/** Devolve o tema do evento, ou `null` quando ele nao tem um. */
export function temaDoEvento(slug) {
  return (slug && TEMAS[slug]) || null
}

export default temaDoEvento
